module.exports = __webpack_public_path__ + "static/logo-88430f02d6272f6ef9481307aaaa39c1.png";